import { ListLoadingType } from './common.models';

/** The values of `ListLoadingType`: which part of a list is loading. */
export const ListLoading = {
  /** The whole list (first page or a reload). */
  List: 'listLoading',
  Next: 'listLoadNext',
  Prev: 'listLoadPrev',
} as const satisfies Record<string, NonNullable<ListLoadingType>>;
